'use strict';

var FollowMeMapUtils = require('./FollowMeMapUtils');
var EventCustomDefinition = require('./track/EventCustomDefinition');

/**
 * General object to provide followme API.
 * @namespace followmeAPILegacy
 */
var followmeAPILegacy = {
  config: {
    dayEventsBaseUrl: window.CONSTANTS.DAY_EVENTS_BASE_URL,
    errorHandler: function ajaxErrorHandler(cb) {
      return function (jqXHR, textStatus, errorThrown) {
        return cb({ message: errorThrown.message, textStatus: textStatus, origin: errorThrown });
      };
    },
    checkRequestStatus: function checkRequestStatus(response) {
      var status = response.find('STATUS');
      var error = response.find('ERROR');
      var e;
      if (error.length > 0) {
        console.error(error[0].outerHTML);
        throw new Error('Server error');
      }
      if (status.attr('value') !== 'OK') {
        e = new Error(status.attr('message'));
        e.errorcode = status.attr('errorcode');
        throw e;
      }
    },
    mapType: null
  },
  getBaseUrl: function() {
    switch (window.storage.getAppMode()) {
      case CONSTANTS.APP_MODE_LEGACY:
        return window.CONSTANTS.BASE_URL_LEGACY;
      case CONSTANTS.APP_MODE_NORMAL:
      default:
        return window.CONSTANTS.BASE_URL;
    }
  },
  setMapType: function(mapType) {
    this.config.mapType = mapType;
  },

  /**
   * Called error on error or empty if all ok
   * @callback defaultCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   */
  /**
   * Called error on error or with data if all ok
   * @callback defaultDataCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {any} data
   */

  /**
   * Returns sessionid token
   * @callback loginCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {string} sessionid Should be used for access to another followme routes
   */
  /**
   * Get sessionid token for user
   * @async
   * @param {string} company
   * @param {string} username
   * @param {string} password
   * @param {loginCallback} cb
   * */
  login: function login(company, username, password, cb) {
    var url = this.getBaseUrl() + '?CMD=LOGIN&ACAO=TRUE&company=' + company + '&user=' + username + '&pass=' + password;
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      success: function success(r) {
        var result;
        try {
          result = $(r);

          self.config.checkRequestStatus(result);

          return cb(null, result.find('STATUS').attr('sessionid'));
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'xml'
    });
  },
  /**
   * Returns result of verification sessionid
   * @callback verifySessionIdCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {string} sessionid Should be used for access to another followme routes
   */
  /**
   * Verify sessionid token for user
   * @async
   * @param {string} sessionid
   * @param {verifySessionIdCallback} cb
   * */
  verifySessionId: function (sessionid, cb) {
    var url = this.getBaseUrl() + '?CMD=FILELIST&ACAO=TRUE&sessionid=' + sessionid;
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null, true);
        } catch (e) {
          if (e.errorcode === '6') {
            return cb(null, false);
          }
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'xml'
    });
  },

  /**
   * Returns list of files for user
   * @callback fileListCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {Array} fileList
   */
  /**
   * Get user file list
   * @async
   * @param {string} sessionid Security token
   * @param {fileListCallback} cb
   * */
  fileList: function getFileList(sessionid, cb) {
    var url = this.getBaseUrl() + '?CMD=FILELIST&ACAO=TRUE&sessionid=' + sessionid;
    var toIgnore = ['userSettings', 'dayevents'];
    var self = this;

    function parseRawFile(rawFile) {
      var j;
      var pv;
      var version;
      var date;
      var devices;
      var days;
      var d;
      var k;
      var versionStatusesAndRemarks = [];
      var versions = [];
      var fileStatusesAndRemarks = [];
      let associatedDevices = [];
      var jqFile = $(rawFile);
      var fileName = jqFile.attr('name');
      let jqAssociatedDevices =  jqFile.find('DEVICE');
      let statusLastUpdate;
      let lastUsedDevice;

      jqAssociatedDevices.each((i, device) => {
        associatedDevices.push($(device).attr('ID'));
      });
      window.storage.appendTrackDeviceIdAssociations({fileName: fileName, deviceIds: associatedDevices});

      pv = jqFile.find('version');
      for (j = 0; j < pv.length; j += 1) {
        version = {
          number: $(pv[j]).attr('value'),
          isTemporary: $(pv[j]).attr('temporaryVersionAvailable')
        };
        versionStatusesAndRemarks = [];
        versions.push(version);

        days = $(pv[j]).find('day');
        for (k = 0; k < days.length; k++) {
          var day = $(days[k]);
          date = day.attr('value');
          devices = day.find('device');

          for (d = 0; d < devices.length; d++) {
            var device = $(devices[d]);
            //lastUsedDevice = devices[d].attributes.id.value;
            //statusLastUpdate = device.attr('lastChangeStatusFile');

            versionStatusesAndRemarks.push({
              date: date,
              deviceId: devices[d].attributes.id.value,
              version: version,
              statusLastChangeDate: device.attr('lastChangeStatusFile'),
              remarksLastChangeDate: device.attr('lastChangeRemarksFile')
            });
          }
          versionStatusesAndRemarks.sort((a, b) => {
            let aDate = new Date(a.statusLastChangeDate);
            let bDate = new Date(b.statusLastChangeDate);

            if(aDate > bDate) {
              return 1;
            } else if(aDate < bDate) {
              return -1;
            } else {
              return 0;
            }
          });
          lastUsedDevice = versionStatusesAndRemarks[versionStatusesAndRemarks.length -1].deviceId;
          statusLastUpdate = versionStatusesAndRemarks[versionStatusesAndRemarks.length -1].statusLastChangeDate;
        }
        fileStatusesAndRemarks.push(versionStatusesAndRemarks);

      }
      return {
        fileName: fileName,
        trackName: fileName,
        creationDate: jqFile.attr('creationdate'),
        modificationDate: jqFile.attr('modificationdate'),
        description: jqFile.attr('description'),
        versions: versions,
        published: jqFile.attr('published'),
        statusLastUpdate: statusLastUpdate,
        lastUsedByDevice: lastUsedDevice,
        statusesAndRemarks: fileStatusesAndRemarks,
        associatedDevices: associatedDevices
      };
    }

    function parseFileForFolder(folderName) {
      return function (files, rawFile) {
        if (toIgnore.indexOf(rawFile.attributes.name.value) !== -1) {
          return files;
        }

        var file = parseRawFile(rawFile);
        file.folderName = folderName;
        files.push(file);
        return files;
      }
    }

    $.ajax({
      type: 'GET',
      url: url,
      error: this.config.errorHandler(cb),
      dataType: 'xml',
      success: function success(r) {
        var result;
        var folder;
        var rawFolders = {};
        var folders = {};
        var i;

        try {
          result = $(r);

          self.config.checkRequestStatus(result);

          rawFolders = result.find('folder');
          for (i = 0; i < rawFolders.length; i += 1) {
            folder = $(rawFolders[i]);
            var folderName = folder.attr('name');

            folders[folderName] = folder.find('file').toArray().reduce(parseFileForFolder(folderName), []);
          }

            if (!folders.default) folders.default = [];
            folders.default = folders.default.concat(result.find('filelist').children('file').toArray()
              .reduce(parseFileForFolder('default'), []));

          return cb(null, folders);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },

/*
  getAllActiveTracks: function getAllActiveTracks(sessionid, cb) {
    var url = this.config.baseUrl + '?CMD=FILELIST&ACAO=TRUE&sessionid=' + sessionid;
    var toIgnore = ['userSettings', 'dayevents'];

    function parseRawFile(rawFile) {
      var j;
      var pv;
      var version;
      var date;
      var devices;
      var days;
      var d;
      var k;
      var versionStatusesAndRemarks = [];
      var versions = [];
      var fileStatusesAndRemarks = [];
      var jqFile = $(rawFile);
      var fileName = jqFile.attr('name');
      let statusLastUpdate;

      pv = jqFile.find('version');
      for (j = 0; j < pv.length; j += 1) {
        version = {
          number: $(pv[j]).attr('value'),
          isTemporary: $(pv[j]).attr('temporaryVersionAvailable')
        };
        versionStatusesAndRemarks = [];
        versions.push(version);

        days = $(pv[j]).find('day');
        for (k = 0; k < days.length; k++) {
          var day = $(days[k]);
          date = day.attr('value');
          devices = day.find('device');
          for (d = 0; d < devices.length; d++) {
            var device = $(devices[d]);

            statusLastUpdate = device.attr('lastChangeStatusFile');

            versionStatusesAndRemarks.push({
              date: date,
              deviceId: devices[d].attributes.id.value,
              version: version,
              statusLastChangeDate: device.attr('lastChangeStatusFile'),
              remarksLastChangeDate: device.attr('lastChangeRemarksFile')
            });
          }
        }
        fileStatusesAndRemarks.push(versionStatusesAndRemarks);

      }

      return {
        fileName: fileName,
        trackName: fileName,
        creationDate: jqFile.attr('creationdate'),
        modificationDate: jqFile.attr('modificationdate'),
        description: jqFile.attr('description'),
        versions: versions,
        published: jqFile.attr('published'),
        statusLastUpdate: statusLastUpdate,
        statusesAndRemarks: fileStatusesAndRemarks
      };
    }

    function parseFileForFolder(folderName) {
      return function (files, rawFile) {
        if (toIgnore.indexOf(rawFile.attributes.name.value) !== -1) {
          return files;
        }

        var file = parseRawFile(rawFile);
        file.folderName = folderName;
        if(new Date().getTime() - CONSTANTS.STATUS_THRESHOLD_FOR_LIVE_TRACKS < new Date(file.statusLastUpdate).getTime()) {
          //files.push(file);
        }
        files.push(file);
        return files;
      }
    }

    $.ajax({
      type: 'GET',
      url: url,
      error: this.config.errorHandler(cb),
      dataType: 'xml',
      success: function success(r) {
        var result;
        var folder;
        var rawFolders = {};
        var folders = {};
        var i;

        try {
          result = $(r);

          followmeAPI.config.checkRequestStatus(result);

          rawFolders = result.find('folder');
          for (i = 0; i < rawFolders.length; i += 1) {
            folder = $(rawFolders[i]);
            var folderName = folder.attr('name');

            folders[folderName] = folder.find('file').toArray().reduce(parseFileForFolder(folderName), []);
          }

          if (!folders.default) folders.default = [];
          folders.default = folders.default.concat(result.find('filelist').children('file').toArray()
            .reduce(parseFileForFolder('default'), []));

          return cb(null, folders);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },*/
  /**
   * Upload file to followme server
   * @async
   * @param {string} sessionid Security token
   * @param {string} data File data
   * @param {string} fileName File name
   * @param {object} trackInfo track information
   * @param {string|int} [trackInfo.version] Target file version
   * @param {string} [trackInfo.folderName] Route folder name
   * @param {defaultCallback} cb
   */
  uploadFile: function uploadFile(sessionid, data, fileName, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=SaveTemporaryPostedRoute&ACAO=TRUE' +
      '&sessionid=' + sessionid +
      '&type=route&route=' + encodeURI(getFullRoute(fileName, trackInfo.folderName));

    if (trackInfo.version) url += '&version=' + trackInfo.version;

    var self = this;

    $.ajax({
      method: 'POST',
      url: url,
      data: data,
      success: function success(r) {
        var result;
        try {
          result = $(r);

          self.config.checkRequestStatus(result);

          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * Called with file data on success or with error on error
   * @callback getFileCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {string} fileData
   */
  /**
   * Get file from followme server
   * @async
   * @param {string} sessionid Security token
   * @param {string} fileName File name
   * @param {object} trackInfo file config
   * @param {number} trackInfo.version Target file version
   * @param {number} trackInfo.folderName file folder
   * @param {boolean} trackInfo.isTemporary is a temporary version
   * @param {getFileCallback} cb
   */
  getFile: function getFile(sessionid, fileName, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=GetFile&ACAO=TRUE' +
      '&sessionid=' + sessionid +
      '&type=route&version=' + trackInfo.version +
      '&route=' + getFullRoute(fileName, trackInfo.folderName);
    if (trackInfo.isTemporary) url += '&temporary=true';
    var self = this;

    $.ajax({
      method: 'GET',
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        if (typeof r === 'string') return cb(null, r);
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(result);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function setRouteAttributes Set's file metadata
   * @async
   * @param sessionid Security token
   * @param {string} route File name
   * @param {object} attributes Key values map to set {key: 'value'}
   * @param {object} trackInfo route config
   * @param {object} trackInfo.folderName route config
   * @param {defaultCallback} cb
   */
  setRouteAttributes: function setRouteAttributes(sessionid, route, attributes, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=SetRouteAttributes&ACAO=TRUE&sessionid=' + sessionid + '&route=' + getFullRoute(route, trackInfo.folderName);

    url = Object.keys(attributes).reduce(function (urlString, attribute) {
      return urlString + '&' + encodeURI(attribute + '=' + attributes[attribute]);
    }, url);

    var self = this;

    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function deleteFile Deletes file
   * @async
   * @param sessionid Security token
   * @param {string} fileName File name
   * @param {string} folder Folder name
   * @param {defaultCallback} cb
   */
  deleteFile: function deleteFile(sessionid, fileName, folder, cb) {
    var url = this.getBaseUrl() + '?CMD=DeleteFile&ACAO=TRUE&sessionid=' + sessionid + '&route=' + getFullRoute(fileName, folder);
    var self = this;

    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with data or with error
   * @callback isTrackNameFreeCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {boolean} isTrackNameFree
   */
  /**
   * @function isTrackNameFree
   * @async
   * @param sessionid Security token
   * @param {string} trackInfo
   * @param {isTrackNameFreeCallback} cb
   * @param {string} fileName
   */
  isTrackNameFree: function isTrackNameFree(sessionid, trackInfo, fileName, cb) {
    var result;
    this.fileList(sessionid, function (e, list) {
      if (e) return cb(e);
      try {
        result = checkTrackNameAvailability(list, trackInfo, fileName);
        return cb(null, result);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * @function uploadTrack Uploads track data and set's metadata
   * @memberof followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} trackData
   * @param {object} trackInfo
   * @param {string} [trackInfo.trackName]
   * @param {string} [trackInfo.trackDescription]
   * @param {string} [trackInfo.creationDate]
   * @param {string} [trackInfo.version]
   * @param {string} [trackInfo.folderName]
   * @param {defaultCallback} cb
   */
  uploadTrack: function uploadTrack(sessionid, route, trackData, trackInfo, cb, overwriteFile) {
    var self = this;
    window.async.waterfall([
      function (callback) {
        if (!trackInfo.trackName) return callback(null, true);
        return self.isTrackNameFree(sessionid, trackInfo, route, callback);
      },
      function (isNameFree, callback) {
        if (!isNameFree && !overwriteFile) return callback(new Error('Current track name is already in use'));
        return self.uploadFile(sessionid, trackData, route, {version: trackInfo.version, folderName: trackInfo.folderName}, callback);
      },
      function (callback) {
        var mapType = window.storage.getSelectedMapType();
        var attributes = {
          modificationDate: (new Date()).toISOString(),
          mapName: mapType.name
        };
        if (trackInfo.trackName) attributes.trackName = trackInfo.trackName;
        if (trackInfo.creationDate) attributes.creationDate = trackInfo.creationDate;
        if (trackInfo.trackDescription) attributes.description = trackInfo.trackDescription;
        self.setRouteAttributes(sessionid, route, attributes, {folderName: trackInfo.folderName},  callback);
      }
    ], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function updateTrackMetadata Used to change track name and description
   * @memberof followmeAPILegacy
   * @async
   * @param {string} sessionId Security token
   * @param oldFileName
   * @param oldFolderName
   * @param newFileName
   * @param newFolderName
   * @param trackDescription
   * @param {defaultCallback} cb
   */
  updateTrackMetadata: function updateTrackMetadata(sessionId, oldFileName, oldFolderName, newFileName, newFolderName, trackDescription, cb) {
    var self = this;

    window.async.waterfall([
      function (callback) {
        self.isTrackNameFree(sessionId, newFileName, oldFileName, callback);
      },
      function (isNameFree, callback) {
        if (!isNameFree) {
          return callback(new Error('Current track name is already in use'));
        }

        if(oldFolderName === newFolderName && oldFileName === newFileName) {
          return callback();
        }

        self.moveFile(sessionId, oldFolderName, newFolderName, oldFileName, newFileName, callback);
      },
      function (callback) {
        var mapType = window.storage.getSelectedMapType();
        var attributes = {
          modificationDate: (new Date()).toISOString(),
          description: trackDescription,
          mapName: mapType.name
        };

        return self.setRouteAttributes(sessionId, newFileName, attributes, {folderName: newFolderName}, callback);
      }
    ], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function dotsToTrackData Converts dots to track csv data
   * @memberof followmeAPILegacy
   * @param {object[]} dotsArray Track dots
   * @param {string} dotsArray[].lat - Dot latitude.
   * @param {string} dotsArray[].lon - Dot longitude
   * @returns {string} Track csv data
   */
  dotsToTrackData: function dotsToTrackData(dotsArray) {
    var i;
    var data = 'lat;long;event.name;event.desc;event.color\n';
    var dots = dotsArray || [];
    var eventStr;
    for (i = 0; i < dots.length; i += 1) {
      if (typeof dots[i] !== 'object' || dots[i].lon === undefined || dots[i].lat === undefined) continue;
      if (dots[i].event) {
        eventStr = ';' + dots[i].event.name + ';' + (dots[i].event.desc || dots[i].event.name) + ';' + (dots[i].event.color || '#ffffff');
      } else {
        eventStr = '';
      }
      data += dots[i].lat + ';' + dots[i].lon + eventStr + '\n';
    }
    return data;
  },
  /**
   * @function dotsToRouteData Converts dots to track csv data
   * @memberof followmeAPILegacy
   * @param {Dots} dots Track dots
   * @param includeCustomEventDefinitions
   * @param {string} format
   * @param {boolean} keepExactContent
   * @returns {string} Track csv data
   */
  dotsToRouteData: function(dots, includeCustomEventDefinitions, format, keepExactContent) {
    if(!format) format = 'csv';

    return FollowMeMapUtils.prepareForExport(dots, includeCustomEventDefinitions, format, keepExactContent);
  },
  /**
   * @function getUserDevices: Returns current user devices in xml format
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {getUserDevicesCallback} cb
   */
  getUserDevices: function getUserDevices(sessionid, cb) {
    this.getUserSettings(sessionid, function (e, data) {
      try {
        if (e) return cb(e);
        var devices = [];
        var devicesXML = $(data).find('device');
        devicesXML.each(function(index, device) {
          devices.push({
            id: device.getAttribute('id'),
            name: device.getAttribute('name')
          });
        });
        cb(null, devices);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * Called with user settings on success or with error on error
   * @callback getUserSettingsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {xml} userSettings
   */
  /**
   * @function getUserSettings Returns current user settings in xml format
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {getUserSettingsCallback} cb
   */
  getUserSettings: function getUserSettings(sessionid, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=GetUserSettings&ACAO=TRUE&sessionid=' + sessionid;

    $.ajax({
      method: 'GET',
      url: url,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) {
            self.config.checkRequestStatus($(r));
          }
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with user settings on success or with error on error
   * @callback setUserSettingsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {xml} userSettings
   */
  /**
   * @function setUserSettings Sets current user settings
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {xml} settings User settings
   * @param {setUserSettingsCallback} cb
   */
  setUserSettings: function setUserSettings(sessionid, settings, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=SetUserSettings&ACAO=TRUE&sessionid=' + sessionid;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      data: settings,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) self.config.checkRequestStatus($(r));
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with array of custom user events on success or with error on error
   * @callback getUserEventsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {object[]} custom events
   */
  /**
   * @function getUserEvents Returns array of custom user events
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {getUserEventsCallback} cb
   */
  getUserEvents: function getUserEvents(sessionid, cb) {
    this.getUserSettings(sessionid, function (e, data) {
      var i = 0;
      var events = [];
      var childNodes;
      try {
        if (e) return cb(e);
        // Edge support
        //childNodes = data.lastElementChild ? data.lastElementChild.childNodes : $(data.childNodes.item(0)).find('event');
        childNodes = $(data).find('event');
        for (i = 0; i < childNodes.length; i += 1) {
          events.push({
            name: childNodes[i].getAttribute('name'),
            id: childNodes[i].getAttribute('id'),
            color: childNodes[i].getAttribute('color'),
            desc: childNodes[i].getAttribute('desc')
          });
        }
        cb(null, events);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * @function addUserEvent Adds new user created event
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} name Custom event name
   * @param {string} color Custom event color
   * @param {string} desc Event description
   * @param {defaultCallback} cb
   */
  addUserEvent: function addUserEvent(sessionid, name, color, desc, cb) {
    var self = this;
    var id = name + '_' + Date.now();
    window.async.waterfall([
      function (callback) {
        self.getUserSettings(sessionid, callback);
      },
      function (data, callback) {
        var userSettings;
        try {
          userSettings = $(data).find('FollowMeServerUserSettings');
          userSettings.append(self.createEventXmlRow(id, name, color, desc));
          self.setUserSettings(sessionid, userSettings[0].outerHTML, callback);
        } catch (e) {
          callback(e);
        }
      }
    ], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function deleteUserEvent Deletes user event by id
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} id EventId
   * @param {defaultCallback} cb
   */
  deleteUserEvent: function addUserEvent(sessionid, id, cb) {
    var self = this;
    window.async.waterfall([
      function (callback) {
        self.getUserSettings(sessionid, callback);
      },
      function (data, callback) {
        var userSettings;
        try {
          userSettings = $(data).find('FollowMeServerUserSettings');
          userSettings.find("[id='" + id + "']").remove();
          self.setUserSettings(sessionid, userSettings[0].outerHTML, callback);
        } catch (e) {
          callback(e);
        }
      }
    ], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  getCustomEventDefinitions: function(sessionid, trackname, callback) {
    this.getUserSettings(sessionid, function (e, data) {

      //TODO: Remove this hack after it applied
      var dataNeedsSaving = false;
      $(data).find('customeventdefinition').each(function () {
        var codeId = parseInt($(this).attr('code'));
        var contentId = parseInt(JSON.parse($(this).text())["code"]);

        if(codeId !== contentId) {
          dataNeedsSaving = true;
          $(this).attr("code", contentId);
        }
      });

      if(dataNeedsSaving) {
        try {
          this.setUserSettings(sessionid, data, function (a, b) {});
        } catch (e) {
          console.error(e);
        }
      }
      //TODO: Remove this hack after it applied

      this.saveCustomDefinitionEventsCache($(data));

      if(trackname === null) {return callback()}
      var i = 0;
      var events = [];
      var childNodes;

      // Edge support
      childNodes = getCustomEventNodeByFilename($(data).find('customeventdefinition'), trackname.replace(/ /g, '-'));

      for (i = 0; i < childNodes.length; i += 1) {
        try {
          var event = childNodes[i];

          events.push(
            new EventCustomDefinition(
              event.attr("code"),
              event.attr("color") ? event.attr("color") : "#5c9eed",
              JSON.parse(event.text()),
              true
            )
          );

        } catch (e) {
          callback(e);
        }

      }

      callback(null, events);
    }.bind(this));
  },
  /**
   * Saves a new Custom Event Definition on the track
   *
   * @param code
   * @param {string} name
   * @param {string} color
   * @param {object} content
   */
  addNewEventCustomDefinition: function (code, name, color, content) {
    var getNextFreeDefinitionCode = function() {
      var code = 40000;
      var currentTrack = window.storage.getTrackInfo().fileName.replace(/ /g, '-');
      var definitions = [];

      var cachedCustomEventDefinitions = window.storage.getCustomEventDefinitions();

      if(cachedCustomEventDefinitions.hasOwnProperty(currentTrack)) {
        definitions = cachedCustomEventDefinitions[currentTrack];
      }

      definitions.forEach(function (definition) {
        var newCode = parseInt(definition.getId());

        if(newCode > code) {
          code = newCode;
        }

      });

      return ++code;
    }.bind(this);

    if(!code) {
      code = getNextFreeDefinitionCode();
    }

    var eventContent = {
      title: name,
      type: "object",
      code: code,
      properties: {},
      required: []
    };

    for(var property in content) {
      if(!content.hasOwnProperty(property)) continue;

      eventContent.properties[property] = {type: content[property].type};
      if(content[property].required) eventContent['required'].push(property);
    }

    var eventDefinition = new EventCustomDefinition(code, color, eventContent, true);
    this.saveEventDefinitionsForTrack(window.storage.getUserToken(), window.storage.getTrackInfo().fileName, [eventDefinition]);
  },
  saveEventDefinitionsForTrack: function(sessionid, filename, definitions, parentCallback) {
    if(definitions.length === 0) return;

    var self = this;
    window.async.waterfall([
      function (callback) {
        self.getUserSettings(sessionid, callback);
      },
      function (data, callback) {
        var customEventDefinitions;
        try {
          var settings = $(data).find('FollowMeServerUserSettings');
          customEventDefinitions = settings.find('customeventdefinitions');

          if(customEventDefinitions.length === 0) {
            customEventDefinitions = $("<customeventdefinitions>");
            settings.append(customEventDefinitions);
          }

          definitions.forEach(function (definition) {
            var customEventDefinition = getCustomEventNodeByFilenameAndCode(customEventDefinitions.find("customeventdefinition"), filename.replace(/ /g, '-'), definition.getId());

            if(customEventDefinition === null) {
              customEventDefinition = $("<customeventdefinition>");
              customEventDefinition.attr('filename', filename.replace(/ /g, '-'));
              customEventDefinition.attr('code', definition.getId());
              customEventDefinition.attr('timestamp', Date.now());
              customEventDefinitions.append(customEventDefinition);
            }

            customEventDefinition.attr('color', definition.getColor());
            customEventDefinition.text(JSON.stringify(definition.getDefinition()));
          });

          self.setUserSettings(sessionid, settings[0].outerHTML, callback);
          var newDefinitions = self.saveCustomDefinitionEventsCache(settings[0].outerHTML);
          window.updateCustomEventsDefinitions(null, newDefinitions);

          if(typeof parentCallback != 'undefined') {
            parentCallback();
          }
        } catch (e) {
          console.error("FollowmeApi.js:741", e);
          callback(e);
        }
      }
    ]);
  },
  /**
   * Removes a custom event definition from the dots
   *
   * @param sessionid
   * @param filename
   * @param {int} code
   */
  removeEventCustomDefinition: function(sessionid, filename, code) {
    var self = this;
    window.async.waterfall([
      function (callback) {
        self.getUserSettings(sessionid, callback);
      },
      function (data, callback) {
        var customEventDefinitions;
        try {
          var settings = $(data).find('FollowMeServerUserSettings');

          customEventDefinitions = settings.find('customeventdefinitions');

          var customEventDefinition = customEventDefinitions.find("[filename=" + filename.replace(/ /g, '-') + "][code=" + code + "]");
          customEventDefinition.remove();

          self.setUserSettings(sessionid, settings[0].outerHTML, callback);
          var newDefinitions = self.saveCustomDefinitionEventsCache(settings[0].outerHTML);
          window.updateCustomEventsDefinitions(null, newDefinitions);
        } catch (e) {
          console.error("FollowmeApi.js:791", e);
          callback(e);
        }
      }
    ]);

  },
  saveCustomDefinitionEventsCache: function(xml) {
    var definitions = {};

    $(xml).find('customeventdefinition').each(function () {
      var filename = $(this).attr("filename");

      if(!definitions.hasOwnProperty(filename)) {
        definitions[filename] = [];
      }

      definitions[filename].push(new EventCustomDefinition(
        $(this).attr("code"),
        $(this).attr("color") ? $(this).attr("color") : "#5c9eed",
        JSON.parse($(this).text()),
        true
      ));
    });

    window.storage.saveCustomEventDefinitions(definitions);

    return definitions;
  },
  /**
   * @function modifyUserEvent Deletes user event by id
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} id EventId
   * @param {string} name Event name
   * @param {string} color Event color
   * @param {string} desc Event description
   * @param {defaultCallback} cb
   */
  modifyUserEvent: function modifyUserEvent(sessionid, id, name, color, desc, cb) {
    var self = this;
    window.async.waterfall([
      function (callback) {
        self.getUserSettings(sessionid, callback);
      },
      function (data, callback) {
        var userSettings;
        try {
          userSettings = $(data).find('FollowMeServerUserSettings');
          userSettings.find("[id='" + id + "']").remove();
          userSettings.append(self.createEventXmlRow(id, name, color, desc));
          self.setUserSettings(sessionid, userSettings[0].outerHTML, callback);
        } catch (e) {
          callback(e);
        }
      }
    ], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function createEventXmlRow Creates custom event in xml format
   * @memberOf followmeAPILegacy
   * @param {string} id
   * @param {string} name
   * @param {string} color
   * @param {string} desc
   * @returns {HTMLElement}
   */
  createEventXmlRow: function createEventXmlRow(id, name, color, desc) {
    var doc = document.implementation.createDocument('', '', null);
    var event = doc.createElement('event');
    event.setAttribute('id', id);
    event.setAttribute('name', name);
    event.setAttribute('color', color);
    event.setAttribute('desc', desc);
    return event;
  },
  /**
   * Called with calculated route data on success or with error on error
   * @callback calculatePostedRouteCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {data} Calculated route data
   */
  /**
   * @function calculatePostedRoute Created route for track
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} data Csv data with lat/long dots in mercator
   * @param {calculatePostedRouteCallback} cb
   */
  calculatePostedRoute: function calculatePostedRoute(sessionid, data, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=CalcPostedRoute&ACAO=TRUE&sessionid=' + sessionid;

    if(this.config.mapType !== null) {
      if(this.config.mapType.hasOwnProperty('hasRouting') && this.config.mapType.hasRouting === false) {
        var userConfig = FollowMeMapUtils.getUserConfig();
        url += "&MAP=" + userConfig.defaultTo;
      } else {
        url += "&MAP=" + this.config.mapType.name;
      }
    }

    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      data: data,
      processData: false,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) self.config.checkRequestStatus($(r));
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function releasePostedRoute Publishes route for user access
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} data Csv data with lat/long dots
   * @param {string} route Route file name
   * @param {string} folderName Route folder name
   * @param {defaultCallback} cb
   */
  releasePostedRoute: function releasePostedRoute(sessionid, data, route, folderName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=ReleasePostedRoute&ACAO=TRUE&route=' + getFullRoute(route, folderName) + '&sessionid=' + sessionid;

    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      data: data,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function unReleaseRoute Unpublishes route for user access
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route Route file name
   * @param {string} folderName file folder
   * @param {defaultCallback} cb
   */
  unReleaseRoute: function unReleaseRoute(sessionid, route, folderName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=UnreleaseRoute&ACAO=TRUE&route=' + getFullRoute(route, folderName) + '&sessionid=' + sessionid;

    $.ajax({
      method: 'POST',
      url: url,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @param sessionid
   * @param route
   * @param folder
   * @param deviceId
   * @param cb
   */
  addDeviceToTrack: function addDeviceToTrack(sessionid, route, folder, deviceId, cb) {
    let self = this;
    let url = this.getBaseUrl() + '?CMD=AddDevice&ACAO=TRUE&device=' + deviceId + '&route=' + getFullRoute(route, folder) + '&sessionid=' + sessionid;

    $.ajax({
      method: 'POST',
      url: url,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @param sessionid
   * @param route
   * @param folder
   * @param deviceId
   * @param cb
   */
  deleteDeviceFromTrack: function deleteDeviceFromTrack(sessionid, route, folder, deviceId, cb) {
    let self = this;
    let url = this.getBaseUrl() + '?CMD=DeleteDevice&ACAO=TRUE&device=' + deviceId + '&route=' + getFullRoute(route, folder) + '&sessionid=' + sessionid;

    $.ajax({
      method: 'POST',
      url: url,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   *
   * @callback getRouteStatusesAndRemarksCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {object} statusAndRemarks
   */
  /**
   * @function getRouteStatusesAndRemarks Returns route statuses and remarks
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} folder Folder name
   * @param {getRouteStatusesAndRemarksCallback} cb
   */
  getRouteStatusesAndRemarks: function getRouteStatusesAndRemarks(sessionid, route, folder, cb) {
    folder = folder || 'default';
    var self = this;
    window.async.waterfall([
      function (cb) {
        self.fileList(sessionid, cb);
      },
      function (fileList, cb) {
        var file = fileList[folder].find(function (file) {
          return file.fileName === route;
        });

        if (!file) return cb();
        cb(null, file.statusesAndRemarks);
      }
    ], function(error, statusAndRemarks) {
      if (error) return cb(error);
      cb(null, statusAndRemarks);
    })
  },

  /**
   * @function getRouteRemark Returns target remarks
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} date remarks date
   * @param {string} deviceId remarks deviceid
   * @param {number} version remarks version
   * @param {string} folderName route folder name
   * @param {defaultDataCallback} cb
   */
  getRouteRemark: function getRouteRemark(sessionid, route, date, deviceId, version, folderName, cb) {
    var url = this.getBaseUrl() + '?CMD=GetRemarks&ACAO=TRUE&sessionid=' + sessionid +
      '&route=' + getFullRoute(route, folderName) + '&version=' + version + '&day=' + date + '&device=' + deviceId;
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },

  /**
   * @function getRouteStatus Returns target status
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} date remarks date
   * @param {string} deviceId remarks deviceid
   * @param {number} version remarks version
   * @param {string} folderName route folder name
   * @param {defaultDataCallback} cb
   */
  getRouteStatus: function getRouteStatus(sessionid, route, date, deviceId, version, folderName, cb) {
    var url = this.getBaseUrl() + '?CMD=GetStatus&ACAO=TRUE&sessionid=' + sessionid +
    '&route=' + getFullRoute(route, folderName) + '&version=' + version + '&day=' + date + '&device=' + deviceId;

    if(this.config.mapType !== null) {
      url += "&MAP=" + this.config.mapType.name;
    }

    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },

  /**
   * @function uploadDayEvent Compresses and uploads day events data
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} data day events data
   * @param {defaultCallback} cb
   */
  uploadDayEvents: function uploadDayEvent(sessionid, data, cb) {
    var url = this.config.dayEventsBaseUrl + '?CMD=UploadFile&sessionid='+sessionid+'&type=dayevents&ACAO=TRUE';

    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'text/plain'
      },
      data: window.pako.deflate(data),
      processData: false,
      success: function success(r) {
        cb();
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function getDayEvents Returns parsed day events
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {defaultDataCallback} cb
   */
  getDayEvents: function getDayEvents(sessionid, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=GetDayEvents&ACAO=TRUE&version=0&sessionid=' + sessionid +
      '&route=dayevents';

    $.ajax({
      type: 'GET',
      url: url,
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, self.parseRawDayEvents(r));
        } catch (e) {
          return cb(e);
        }
      }
    });
  },

  /**
   * @function dayEventJsonToXml Converts day event object to xml row
   * @memberOf followmeAPILegacy
   * @param {DayEvent} dayEvent
   */
  dayEventJsonToXml: function dayEventJsonToXml(dayEvent) {
    var wgs84cords = dayEvent.coordinates.toWGS84();
    return $("<DAYEVENT>", {description: dayEvent.name, coordx: wgs84cords._x, coordy: wgs84cords._y}).append(
      $("<DATE>", {type: dayEvent.type, from: dayEvent.fromDate, to: dayEvent.toDate, weekday: weekDayToNumber(dayEvent.weekday)})
    )[0];
  },

  /**
   * @function dayEventsToXml Creates day events xml from DayEvent array
   * @memberOf followmeAPILegacy
   * @param {DayEvent[]} dayEvents
   */
  dayEventsToXml: function dayEventsToXml(dayEvents) {
    var xmlVersion = '<?xml version="1.0"?>\n';
    var dayEventsRows = dayEvents.map(this.dayEventJsonToXml);
    var xml = $("<FOLLOWME>").append($('<DAYEVENTS>', {tour: ""}).append(dayEventsRows));
    return xmlVersion + xml[0].outerHTML;
  },

  /**
   *
   * @callback modifyDayEventsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {DayEvent[]} updatedDayEvents
   */
  /**
   * @function modifyDayEvents Loads day events passes to function and uploads to server
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {Function} fn function to modify day events array
   * @param {modifyDayEventsCallback} callback
   */
  modifyDayEvents: function addDayEvent(sessionid, fn, callback) {
    var self = this;
    var updatedDayEvents;
    window.async.waterfall([
      function (cb) {
        self.getDayEvents(sessionid, cb);
      },
      function (dayEvents, cb) {
        try {
          dayEvents = fn(dayEvents);
          updatedDayEvents = dayEvents;
          self.uploadDayEvents(sessionid, self.dayEventsToXml(dayEvents), cb)
        } catch (e) {
          cb(e);
        }
      }
    ], function (e) {
      callback(e, updatedDayEvents);
    });
  },

  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {DayEvent} dayEvent day event to add
   * @param {modifyDayEventsCallback} callback
   */
  addDayEvent: function addDayEvent(sessionid, dayEvent, callback) {
    function isEventNameUniq(dayEvents) {
      return !dayEvents.find(function (event) {
        return event.name === dayEvent.name
      });
    }

    this.modifyDayEvents(sessionid, function (dayEvents) {
      if (!isEventNameUniq(dayEvents)) {
        throw new Error('Event name "' + dayEvent.name + '" already in use!');
      }
      dayEvents.push(dayEvent);
      return dayEvents;
    }, callback);
  },
  /**
   * @function parseRawDayEvents Convertes xml to DayEvent[]
   * @param {xml} rawDayEvents
   * @returns {DayEvent[]}
   */
  parseRawDayEvents: function parseRawDayEvents(rawDayEvents) {
    if (!rawDayEvents.features) {
      return [];
    }
    return rawDayEvents.features.map(function (feature) {
      return {
        name: feature.properties.TEXT,
        type: feature.properties.TYPE.toLowerCase(),
        weekday: getWeekDayLiteral(+feature.properties.WEEKDAY),
        fromDate: +feature.properties.UTC_FROM,
        toDate: +feature.properties.UTC_TO,
        coordinates: new IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1], IWCoordinate.MERCATOR)
      };
    });
  },

  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} originalName Original day event name
   * @param {DayEvent} dayEvent day event to update
   * @param {modifyDayEventsCallback} callback
   */
  updateDayEvent: function updateDayEvent(sessionid, originalName, dayEvent, callback) {
    this.modifyDayEvents(sessionid, function (dayEvents) {
      var targetEventIndex = dayEvents.findIndex(function (event) {
        return event.name === originalName;
      });

      if (targetEventIndex === -1) throw new Error('Event with name "' + originalName + '" do not exists!');
      dayEvents[targetEventIndex] = dayEvent;
      return dayEvents;
    }, callback);
  },

  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {DayEvent} dayEvent day event to delete
   * @param {modifyDayEventsCallback} callback
   */
  deleteDayEvent: function deleteDayEvent(sessionid, dayEvent, callback) {
    this.modifyDayEvents(sessionid, function (dayEvents) {
      dayEvents = dayEvents.filter(function (event) {
        return event.name !== dayEvent.name;
      });
      return dayEvents;
    }, callback);
  },

  /**
   * @function createFolder Creates folder for user
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} folderName
   * @param {defaultCallback} cb
   */
  createFolder: function createFolder(sessionid, folderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=CreateFolder&sessionid='+sessionid+'&ACAO=TRUE&folder=/' + folderName;

    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function renameFolder Renames folder of user
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} oldFolderName
   * @param {string} newFolderName
   * @param {defaultCallback} cb
   */
  renameFolder: function renameFolder(sessionid, oldFolderName, newFolderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=RenameFolder&sessionid='+sessionid+'&ACAO=TRUE&' +
      'folder=/' + oldFolderName +
      '&newFolder=/' + newFolderName;

    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function deleteFolder Deletes user`s folder
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} folderName Folder to delete
   * @param {defaultCallback} cb
   */
  deleteFolder: function deleteFolder(sessionid, folderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=DeleteFolder&sessionid='+sessionid+'&ACAO=TRUE&folder=/' + folderName;

    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function moveFile moves file to new folder
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} oldFolder Old folder name
   * @param {string} newFolder New folder name
   * @param {string} oldFileName
   * @param {string} newFileName
   * @param {defaultCallback} cb
   */
  moveFile: function moveFile(sessionid, oldFolder, newFolder, oldFileName, newFileName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=MoveFile&sessionid='+sessionid+'&ACAO=TRUE' +
      '&folder=' + oldFolder + '&file=' + getFullRoute(oldFileName, oldFolder) +
      '&newPath=' + getFullRoute(newFileName, newFolder);

    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },

  /**
   * @function getMapTypes Gets all the map types available on the NaviServer
   * @async
   * @memberOf followmeAPILegacy
   * @param {callback} cb
   */
  getMapTypes: function(cb) {
    var url = this.getBaseUrl() + '?CMD=GETAVAILABLEMAPS&ACAO=TRUE';
    $.ajax({
      method: 'GET',
      url: url,
      success: function success(response) {
        try {
          return cb(null, response);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  }
};

function getCustomEventNodeByFilename(definitions, filename) {
  var result = [];
  definitions.each(function() {
    if($(this).attr("filename") === filename) {
      result.push($(this));
    }
  });

  return result;
}

function getCustomEventNodeByFilenameAndCode(definitions, filename, code) {
  var definition = null;

  definitions.each(function() {
    if($(this).attr("filename") === filename && parseInt($(this).attr("code")) === code) {
      definition = $(this);
      return false;
    }
  });

  return definition;
}

/**
 * @function checkTrackNameAvailability Returns true if list does'n consist track name or this track name for target filename
 * @param {Object[]} list
 * @param {string} trackInfo
 * @param {string} fileName
 * @returns {boolean} Is track name free
 */
function checkTrackNameAvailability(list, trackInfo, fileName) {
  var trackData;
  var folderNames = Object.keys(list);
  var trackNameIsAvailable = true;

  for (var i = 0; i < folderNames.length; i ++) {
      trackData = list[folderNames[i]].find(function(track) {
        if ((fileName && fileName === track.fileName) && ( trackInfo.folderName === folderNames[i])) trackNameIsAvailable = false;
        return track.trackName === trackInfo.trackName;
      });
      if (trackData) break;
  }
  return (!trackData || trackNameIsAvailable);
}

function getWeekDayLiteral(dayWeekNumber) {
  var weekday = {
    0: 'monday',
    1: 'tuesday',
    2: 'wednesday',
    3: 'thursday',
    4: 'friday',
    5: 'saturday',
    6: 'sunday'
  };
  return weekday[dayWeekNumber];
}

function weekDayToNumber(targetWeekday) {
  var weekdays = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
  ];
  return weekdays.findIndex(function (weekday) {
    return weekday === targetWeekday;
  });
}

function getFullRoute(fileName, folder) {
  var routeString = fileName;
  if (folder && folder !== 'default') routeString = folder + '/' + fileName;
  return routeString;
}

module.exports = followmeAPILegacy;
